import React from 'react';
import { Combo } from 'fw/forms';
import * as API from 'modules/app/API'

class EmailTemplateCombo extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
        this._isMounted = false;
    }

    completed = () => { return this._ctrl.completed(); }
    flag = () => { return this._ctrl.flag(); }

    componentDidMount() {
		this._isMounted = true;
		API.Emailing.get('/emailTemplateSetup/getTemplates', { emailTemplateType: this.props.emailTemplateType},
			{
				success: (r) => {
					this._isMounted && this.setState({
						items: r.data.items.map((item) => { return { label: item.name, value: item.emailTemplateCode } })
					});
				}
			},
			{ block: false });
	}

    componentWillUnmount() {
		this._isMounted = false;
	}

    render() {
        return (
            <Combo
                {...this.props}
                placeholder="Email Template..."
                items={this.state.items}
                searchable={true}
                ref={(c) => { this._ctrl = c}} />
        )
    }
}

export default EmailTemplateCombo;

// Mark this as a form component
EmailTemplateCombo.defaultProps = {
    formControl: true,
    managed: false
};



// WEBPACK FOOTER //
// ./src/areas/shared/controls/emailTemplateCombo/EmailTemplateCombo.js